import classNames from 'classnames';
import { observer } from 'mobx-react';
import SortingButton from '../Controls/SortingButton/SortingButton';
import Text, { TEXT } from '../Text/Text';
import { SORTING_DIRECTION } from 'src/constants/main';
import { ICustomTooltipProps } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import './style.scss';

export interface IColumnTitle<T> {
  title: string;
  columnName?: T;
  currentField?: T | null;
  currentDir?: SORTING_DIRECTION | null;
  noTitleTranslate?: boolean;
  setFilters?: (sortField: T | undefined, sortDir: SORTING_DIRECTION) => void;
  className?: string;
  textClassName?: string;
  //
  tooltipMessage?: string;
  tooltipProps?: Partial<ICustomTooltipProps>;
}

const ColumnTitle = observer(<T,>({ setFilters, ...props }: IColumnTitle<T>): JSX.Element => {
  return (
    <div className={classNames('column-title', props.className)}>
      {props.columnName ? (
        <SortingButton<T> sortField={props.columnName} currentField={props.currentField} currentDir={props.currentDir} changeSorting={setFilters}>
          <Text type={TEXT.COLUMN_TITLE} text={props.title} defaultValue="" className={props.textClassName} noTranslate={props.noTitleTranslate} />
        </SortingButton>
      ) : (
        <Text type={TEXT.COLUMN_TITLE} text={props.title} defaultValue="" className={props.textClassName} noTranslate={props.noTitleTranslate} />
      )}

      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <TooltipIcon message={props.tooltipMessage} {...props.tooltipProps} />
    </div>
  );
});

export default ColumnTitle;
